import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PageEditor from '../components/PageEditor';
import Modal from '../components/Modal';

const Admin = () => {
  const [activeTab, setActiveTab] = useState('users');
  const [users, setUsers] = useState([]);
  const [deletedUsers, setDeletedUsers] = useState([]);
  const [showDeleted, setShowDeleted] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentEditingUser, setCurrentEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    nickname: '',
    email: '',
    phone: '',
    city: '',
    state: '',
    role: 'user',
    password: ''
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const [activeRes, deletedRes] = await Promise.all([
        axios.get('/api/admin/users'),
        axios.get('/api/admin/users/deleted')
      ]);
      setUsers(activeRes.data);
      setDeletedUsers(deletedRes.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleEdit = (user) => {
    setCurrentEditingUser(user);
    setFormData({
      firstName: user.firstName,
      lastName: user.lastName,
      nickname: user.nickname,
      email: user.email,
      phone: user.phone,
      city: user.city,
      state: user.state,
      role: user.role,
      password: ''
    });
    setIsModalOpen(true);
  };

  const handleSave = async () => {
    try {
      if (currentEditingUser) {
        await axios.put(`/api/admin/users/${currentEditingUser._id}`, formData);
      } else {
        await axios.post('/api/admin/users', formData);
      }
      fetchUsers();
      handleCancel();
    } catch (error) {
      console.error('Error saving user:', error);
      alert('Error saving user: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleDelete = async (userId) => {
    const confirmed = window.confirm('Are you sure you want to delete this user? This action cannot be undone.');
    if (!confirmed) return;
    try {
      await axios.delete(`/api/admin/users/${userId}`);
      fetchUsers();
    } catch (error) {
      console.error('Error deleting user:', error);
      alert('Error deleting user: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleRestore = async (userId) => {
    try {
      await axios.post(`/api/admin/users/${userId}/restore`);
      fetchUsers();
    } catch (error) {
      console.error('Error restoring user:', error);
      alert('Error restoring user: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setCurrentEditingUser(null);
    setFormData({
      firstName: '',
      lastName: '',
      nickname: '',
      email: '',
      phone: '',
      city: '',
      state: '',
      role: 'user',
      password: ''
    });
  };

  const UserEditModal = () => (
    <Modal
      isOpen={isModalOpen}
      onClose={handleCancel}
      title={currentEditingUser ? "Edit User" : "Add New User"}
    >
      <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>
              First Name
            </label>
            <input
              type="text"
              value={formData.firstName}
              onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px'
              }}
              required
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>
              Last Name
            </label>
            <input
              type="text"
              value={formData.lastName}
              onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px'
              }}
              required
            />
          </div>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>
            Nickname (Optional)
          </label>
          <input
            type="text"
            value={formData.nickname}
            onChange={(e) => setFormData({ ...formData, nickname: e.target.value })}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '6px',
              fontSize: '14px'
            }}
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>
              Email
            </label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px'
              }}
              required
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>
              Phone
            </label>
            <input
              type="tel"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            />
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>
              City
            </label>
            <input
              type="text"
              value={formData.city}
              onChange={(e) => setFormData({ ...formData, city: e.target.value })}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>
              State
            </label>
            <input
              type="text"
              value={formData.state}
              onChange={(e) => setFormData({ ...formData, state: e.target.value })}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            />
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>
            Role
          </label>
          <select
            value={formData.role}
            onChange={(e) => setFormData({ ...formData, role: e.target.value })}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '6px',
              fontSize: '14px',
              background: 'white'
            }}
          >
            <option value="user">User</option>
            <option value="manager">Manager</option>
            <option value="admin">Admin</option>
          </select>
        </div>

        {currentEditingUser && (
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>
              New Password (leave blank to keep current)
            </label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            />
          </div>
        )}

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              background: '#f5f5f5',
              color: '#333',
              border: '1px solid #ddd',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            style={{
              padding: '10px 20px',
              background: '#1e3c72',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            {currentEditingUser ? 'Update User' : 'Add User'}
          </button>
        </div>
      </form>
    </Modal>
  );

  return (
    <div style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", background: "#031A54", minHeight: "100vh", padding: "20px" }}>
      <div style={{ maxWidth: "1400px", margin: "0 auto", background: "white", borderRadius: "12px", boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)" }}>
        <div style={{ background: "#9584AC", color: "white", padding: "25px", textAlign: "center" }}>
          <h1 style={{ fontSize: "2rem", marginBottom: "10px" }}>ADMIN PANEL</h1>
          <p>User Management System</p>
        </div>

        <div style={{ padding: "20px" }}>
          <div style={{ marginBottom: "30px" }}>
            <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
              <button
                onClick={() => setActiveTab('users')}
                style={{
                  padding: "10px 20px",
                  background: activeTab === 'users' ? "#1e3c72" : "#f5f5f5",
                  color: activeTab === 'users' ? "white" : "#333",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "bold"
                }}
              >
                User Management
              </button>
              <button
                onClick={() => setActiveTab('pages')}
                style={{
                  padding: "10px 20px",
                  background: activeTab === 'pages' ? "#1e3c72" : "#f5f5f5",
                  color: activeTab === 'pages' ? "white" : "#333",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "bold"
                }}
              >
                Page Editor
              </button>
            </div>
          </div>

          {/* Tab Content */}
          {activeTab === 'users' && (
            <div style={{ background: "white", borderRadius: "12px", overflow: "hidden", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#1e3c72", color: "white" }}>
                    <th style={{ padding: "15px", textAlign: "left" }}>Name</th>
                    <th style={{ padding: "15px", textAlign: "left" }}>Email</th>
                    <th style={{ padding: "15px", textAlign: "left" }}>Role</th>
                    <th style={{ padding: "15px", textAlign: "left" }}>Location</th>
                    <th style={{ padding: "15px", textAlign: "center" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => (
                    <tr key={user._id} style={{ borderBottom: "1px solid #e0e0e0" }}>
                      <td style={{ padding: "15px" }}>
                        {user.firstName} {user.lastName}
                        {user.nickname && <span style={{ color: "#666", fontSize: "0.9em" }}> ({user.nickname})</span>}
                      </td>
                      <td style={{ padding: "15px" }}>{user.email}</td>
                      <td style={{ padding: "15px" }}>
                        <span style={{
                          padding: "4px 8px",
                          borderRadius: "4px",
                          fontSize: "0.8em",
                          background: user.role === 'admin' ? '#d32f2f' : user.role === 'manager' ? '#f57c00' : '#4caf50',
                          color: "white"
                        }}>
                          {user.role}
                        </span>
                      </td>
                      <td style={{ padding: "15px" }}>
                        {user.city && user.state ? `${user.city}, ${user.state}` : user.city || user.state || 'N/A'}
                      </td>
                      <td style={{ padding: "15px", textAlign: "center" }}>
                        <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
                          <button
                            onClick={() => handleEdit(user)}
                            style={{ padding: "6px 12px", background: "#2196f3", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" }}
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDelete(user._id)}
                            style={{ padding: "6px 12px", background: "#d32f2f", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" }}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {activeTab === 'pages' && (
            <div style={{ marginTop: "20px" }}>
              <PageEditor page="about" />
            </div>
          )}

          <div style={{ padding: "15px", textAlign: "center", background: "#f5f5f5", color: "#666", fontSize: "0.85rem" }}>
            <p>Craps Players League ©2025</p>
          </div>
        </div>
      </div>
      <UserEditModal />
    </div>
  );
};

export default Admin;